import { useOfficeComponentContext } from '@office-start/component-context-service';
import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import { IDLE_VERYLOW_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy } from 'react';
export var DeleteDialog = function () {
    var _a;
    var componentContext = (_a = useOfficeComponentContext()) === null || _a === void 0 ? void 0 : _a.data;
    var DeleteDialogLazy = withLazyErrorBoundary(lazy(function () {
        return import(
        /*webpackChunkName: "delete-dialog-component" */ '@office-start/delete-dialog-component');
    }), 'DeleteDialog', {
        disabled: !componentContext,
        schedulePriority: IDLE_VERYLOW_PRIORITY,
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return React.createElement(DeleteDialogLazy, null);
};
//# sourceMappingURL=DeleteDialog.js.map